import React, { Component } from 'react';


class PasswordForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            oldPassword: '',
            newPassword: '',
            userPasswordChange: {},
        }
    }
    
    render() { 
        return (
            <div className="row pt-5 pb-5 mx-1">
                <form className="my-form border border-dark p-5" onSubmit={(e) => this.handlePasswordChange(e, localStorage.getItem("token"))}>
                    <h1 className="text-center text-danger mb-5">Change Password</h1>
                    <div className="form-group">
                        <input type="password" className="form-control bg-dark text-white text-center mb-3" id="oldPassword" placeholder="Old password" maxLength="75" required 
                            value={this.state.oldPassword} 
                            onChange={e => this.setState({ oldPassword: e.target.value })}
                        />
                        <input type="password" className="form-control mt-1 bg-dark text-white text-center mb-5" id="newPassword" placeholder="New password" maxLength="75" required 
                            value={this.state.newPassword} 
                            onChange={e => this.setState({ newPassword: e.target.value })}
                        />
                    </div>
                    <div className="text-center">
                        <button type="submit" className="btn btn-success btn-lg submit-button">Submit</button>
                    </div>
                </form>
            </div>
        );
    }

    handlePasswordChange = (e, token) => {
        e.preventDefault();
        this.setState({ userPasswordChange: {
            oldPassword: this.state.oldPassword,
            newPassword: this.state.newPassword
        }}, () => {
            fetch(process.env.REACT_APP_CHANGEPASSWORD + token, {
                method: 'put',
                mode: 'cors',
                body: JSON.stringify(this.state.userPasswordChange),
                headers: {
                    "Content-type" : "application/json"
                }
            }).then(response => response.json()).then(json => {
                alert(json.message);
                this.setState({
                    oldPassword: '',
                    newPassword: '',
                    userPasswordChange: {}
                })
            })
        })
    }
}
 
export default PasswordForm;